(function () {
  const SECTION_ID = 'sf-cart-recommendations';
  let container;

  function getBaseProductId() {
    const items = window.liquidAjaxCart?.cart?.items || [];
    if (!items.length) return null;
    return items[items.length - 1].product_id; // base recs on most recently added item
  }

  function getCartProductIds() {
    const items = window.liquidAjaxCart?.cart?.items || [];
    return items.map((i) => String(i.product_id));
  }

  async function loadRecommendations() {
    if (!container) return;

    const productId = getBaseProductId();
    if (!productId) {
      container.innerHTML = '';
      return;
    }

    const url = `/recommendations/products?section_id=${SECTION_ID}&product_id=${productId}&limit=8&intent=related`;

    try {
      const res = await fetch(url);
      if (!res.ok) return;

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cartIds = getCartProductIds();

      doc.querySelectorAll('[data-product-id]').forEach((el) => {
        if (cartIds.includes(el.getAttribute('data-product-id'))) el.remove();
      });

      const remaining = doc.querySelectorAll('.cart-recommendation-item');
      remaining.forEach((el, index) => {
        if (index >= 4) el.remove();
      });

      container.innerHTML = doc.querySelectorAll('.cart-recommendation-item').length
        ? doc.body.innerHTML
        : '';
    } catch (e) {
      console.error('Cart recommendations failed to load', e);
    }
  }

  function init() {
    container = document.getElementById('cart-recommendations-container');
    if (!container) return;
    loadRecommendations();
    document.addEventListener('liquid-ajax-cart:request-end', loadRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();